/**
 * On change orders the server-side clone (integrations-api create_change_order) copies
 * every source row, including fixed summary rows. Mid-clone the browser sees a partial
 * quote and would recreate rows the clone is still copying, producing duplicates — so
 * a fixed summary row may only be created when the source quote has no row for that
 * product (copied or in flight otherwise).
 *
 * Kept import-free so it stays unit-testable (see product-search-helpers.ts).
 */
export function changeOrderSourceHasProduct(
  productId: string,
  isChangeOrder: boolean,
  sourceQuoteDetails: { productid: { productid: string } }[] | undefined
) {
  return isChangeOrder && !!sourceQuoteDetails?.some((d) => d.productid.productid === productId)
}
